module.exports = __webpack_public_path__ + "media/images/common/logo_tokaicoop-c6e6ab5051997f79493aed5afd109578.png";